<template>
  <div class="home">
    <van-nav-bar title="地址维护" left-text="返回" right-text left-arrow fixed @click-left="onClickLeft" />
    <div style="height:46px"></div>
    <van-address-edit
      ref="address"
      :area-list="areaList"
      show-postal
      show-delete
      show-set-default
      :address-info="addressInfo"
      :area-columns-placeholder="['请选择', '请选择', '请选择']"
      @save="onClick"
      @delete="delAddress"
      @change-default="onDefault"
    />
  </div>
</template>
<script>
import Vue from "vue";
import { AddressEdit } from "vant";
import AreaList from "@/assets/area.js";
Vue.use(AddressEdit);
export default {
  name: "addressAdd",
  data() {
    return {
      areaList: AreaList,
      searchResult: [],
      addressInfo: { name: "" },
      user: { token: "", user: {} },
      id: this.$route.params.id
    };
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    getAddress() {
      this.$http
        .get(
          this.GLOBAL.API + "s_shop/address/getAddress",

          {
            params: { id: this.id },
            headers: { "XX-Token": this.user.token, "XX-Device-Type": "mobile" }
          }
        )
        .then(response => {
          let data = response.body;
          if (data.code == 1) {
            let d = data.data;
            this.addressInfo.id = d.id;
            this.addressInfo.name = d.true_name;
            this.addressInfo.tel = d.tel;
            this.addressInfo.addressDetail = d.address;
            this.addressInfo.postalCode = d.post;
            //   this.addressInfo.name = 'gggggg';
            console.log(this.addressInfo);
          }
        });
    },
    delAddress() {
      this.$http
        .post(
          this.GLOBAL.API + "/s_shop/address/del",
          {
            id: this.id
          },
          {
            params: {},
            headers: { "XX-Token": this.user.token, "XX-Device-Type": "mobile" }
          }
        )
        .then(response => {
          let data = response.body;
          this.$toast(data.msg);
          if (data.code == 1) {
            this.$router.go(-1);
          }
        });
    },
    onClick(content) {
      if (this.id > 0) {
        this.onSave(content);
      } else {
        this.onCreate(content);
      }
    },
    onSave(content) {
      //   let a = this.$refs.address.data;
      console.log(content);

      this.$http
        .post(
          this.GLOBAL.API + "/s_shop/address/edit",
          {
            id: this.id,
            true_name: content.name,
            tel: content.tel,
            area: content.province + content.city + content.county,
            address: content.addressDetail,
          },
          {
            params: {},
            headers: { "XX-Token": this.user.token, "XX-Device-Type": "mobile" }
          }
        )
        .then(response => {
          let data = response.body;
          this.$toast(data.msg);
          if (data.code == 1) {
            this.$router.push("/user/addresslist");
          }
        });
    },
    onCreate(content) {
      //   let a = this.$refs.address.data;
      console.log(content);

      this.$http
        .post(
          this.GLOBAL.API + "/s_shop/address/add",
          {
            true_name: content.name,
            tel: content.tel,
            area: content.province + content.city + content.county,
            address: content.addressDetail
          },
          {
            params: {},
            headers: { "XX-Token": this.user.token, "XX-Device-Type": "mobile" }
          }
        )
        .then(response => {
          let data = response.body;
          this.$toast(data.msg);
          if (data.code == 1) {
            this.$router.push("/user/addresslist");
          }
        });
    },
    onDefault(val) {
      if (val&&this.id>0) {
        this.$http
        .post(
          this.GLOBAL.API + "/s_shop/address/setDefault",
          {
            id:this.id
          },
          {
            params: {},
            headers: { "XX-Token": this.user.token, "XX-Device-Type": "mobile" }
          }
        )
        .then(response => {
          let data = response.body;
          this.$toast(data.msg);
          
        });
      } 
    }
  },
  mounted() {
    if (JSON.parse(localStorage.getItem("user"))) {
      this.user = JSON.parse(localStorage.getItem("user"));
      if (this.id > 0) {
        this.getAddress();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.home {
  height: 100%;
  background-color: #f6f6f6;
}
</style>